module.exports = __webpack_public_path__ + "static/media/silkycloud-black-2.269d90db.png";